import { fieldErrorsForAliases } from "@cmts/errors/index.js";
import { SwotFieldError } from "@swot-shared/feedback/index.js";

export type FieldErrorsProps = {
  readonly fieldName: string;
  readonly errors?: Record<string, string[]> | undefined;
  readonly aliases?: readonly string[] | undefined;
};

export function FieldErrors(props: FieldErrorsProps) {
  const messages = fieldErrorsForAliases(props.errors ?? {}, props.fieldName, props.aliases ?? []);
  if (messages.length === 0) return null;
  const errorId = `${props.fieldName}-errors`;
  return (
    <span className="cmts-field-errors" role="alert" aria-live="polite" aria-describedby={errorId}>
      <SwotFieldError fieldName={props.fieldName} messages={messages} />
    </span>
  );
}
